<script setup lang="ts">
import { ref, onMounted } from 'vue';
import Cookies from 'universal-cookie';

const cookies = new Cookies();
const cookiesLabel = 'cookieConsent';
const COOKIE_EXPIRATION_TIME = 365 * 24 * 60 * 60 * 1000;

const accepted = ref(false);
const showCookiePopup = ref(false);

onMounted(() => {
  if (!cookies.get(cookiesLabel)) {
    showCookiePopup.value = true;
  }
});

const acceptCookies = () => {
  cookies.set(cookiesLabel, 'true', {
    path: '/',
    expires: new Date(Date.now() + COOKIE_EXPIRATION_TIME),
  });
  accepted.value = true;
  showCookiePopup.value = false;
};

const declineCookies = () => {
  cookies.set(cookiesLabel, 'declined', {
    path: '/',
    expires: new Date(Date.now() + COOKIE_EXPIRATION_TIME),
  });
  showCookiePopup.value = false;
};
</script>

<template>
  <div
    v-if="showCookiePopup"
    class="fixed bottom-0 left-0 right-0 z-100 border-t border-black bg-white py-6 md:py-3"
  >
    <div class="container min-h-[146px] items-center gap-6 md:flex">
      <div class="flex-1">
        <h3 class="title mb-0.5 block">This website uses cookies</h3>
        <p>
          Our website uses cookies to improve your browsing experience. By using
          our site you agree to the use of cookies.
        </p>
      </div>
      <div class="mt-2 flex gap-4 gap-x-11 md:mt-0">
        <Button
          :type="'button'"
          :title="'ACCEPT'"
          icon="arrow-r"
          :class="'px-8 py-2.5'"
          aria-label="Accept cookies"
          @click="acceptCookies"
        />
        <ButtonLink
          :type="'button'"
          :title="'DECLINE'"
          icon="arrow-r"
          aria-label="Decline cookies"
          @click="declineCookies"
        />
      </div>
    </div>
  </div>
</template>
